import { SausageStyleColor } from "../../logic/enums.ts";
import { getTailwindBackgroundColor } from "../../logic/logic.js";

const ColorIndicator = ({ doShow = true, color = SausageStyleColor.Pink }) => {
  const tailwindBackgroundColor = getTailwindBackgroundColor(color);

  if (doShow === false) {
    return null;
  }

  return (
    <div
      className={`flex items-center justify-center w-7 h-7 aspect-square rounded-full  border-2 border-white ${tailwindBackgroundColor}`}
    >
      <div className="w-2 h-2 bg-white opacity-40 rounded-full translate-y-1 translate-x-1" />
    </div>
  );
};

export default ColorIndicator;
